// extracted by mini-css-extract-plugin
export var gitHubAlertLink = "styles-module--gitHubAlertLink--e87f9";
export var header = "styles-module--header--6ecf4";
export var headerContainer = "styles-module--headerContainer--8770e";